import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import {
  BusinessRuleBodyApplyInputDTO,
  BusinessRuleVertionDataOutputDTO,
  DestinationType,
  FormulaGlobalVariablesOutputDTO,
  RuleType,
} from './businessRuleDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class BusinessRuleServices {
  async getById(id: number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByAll(param: string | null = null): Promise<any[]> {
    const getUrl = (param: string | null = null) => {
      if (!param) {
        return `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/`
      }
      return `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/?${param}`
    }

    try {
      const res = await axios.get(getUrl(param), {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getRuleTypes(): Promise<RuleType[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/rule-type/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getRuleTypesById(id: number): Promise<RuleType> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/rule-type/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getGatewayByValues(params: string): Promise<RuleType[] | RuleType> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BUSINESS_RULE}/gateway/?operator=or_equal${params}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getGateways(): Promise<RuleType[] | RuleType> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/gateway/all/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinationTypes(): Promise<DestinationType[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/destination-type/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinationTypeById(id: number): Promise<DestinationType> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/destination-type/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAirlines(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-air-airline/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAirSources(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-air-source/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinations(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-air-destination/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getSuppliers(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-hotel-supplier/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCountries(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-hotel-country/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCitiesByCountry(country_code: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-hotel-city-by-country/${country_code}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getHotelSources(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-hotel-source/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getPaymentTypesByWorkUnitToken(workUnitToken: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-type-by-work-unit/token/${workUnitToken}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getPaymentMethods(url: string): Promise<any[]> {
    try {
      const res = await axios.get(url, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getStaticJson(workUnitToken: string, productToken: string, ruleTypeId: string): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/json-static/json/`, {
        headers: { 'authentication-token': getJWT()! },
        params: {
          work_unit_token: workUnitToken,
          product_token: productToken,
          rule_type_id: ruleTypeId,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getVertions(
    rule_id: number,
    version_id: number
  ): Promise<BusinessRuleVertionDataOutputDTO[] | BusinessRuleVertionDataOutputDTO> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/${rule_id}/version/`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: version_id ? { version_id: version_id } : null,
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async solvedFormula(formula: any): Promise<any> {
    // this dont have validation jwt
    const res = await axios.post(`${process.env.REACT_APP_URL_FORMULA}`, formula)
    return res.data
  }

  async solvedFormulaTest(formula: JSON, parent_id: number | null): Promise<any> {
    // this dont have validation jwt
    const res = await axios.post(
      `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/testRule`,
      {
        formula,
        parent_id,
      },
      {
        headers: { 'authentication-token': getJWT()! },
      }
    )
    return res.data
  }

  async applyRule(rule_body: BusinessRuleBodyApplyInputDTO): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/applyRule`,
        {
          ...rule_body,
        },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async combineRules(formula: JSON, parent_id: number | null): Promise<any> {
    // this dont have validation jwt
    const res = await axios.post(
      `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/combineRule/`,
      {
        formula,
        parent_id,
      },
      {
        headers: { 'authentication-token': getJWT()! },
      }
    )
    return res.data
  }

  async combineData(dicc: JSON | null, dicc_inherited: JSON | null): Promise<any> {
    // this dont have validation jwt
    const res = await axios.post(
      `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/combineData/`,
      {
        dicc,
        dicc_inherited,
      },
      {
        headers: { 'authentication-token': getJWT()! },
      }
    )
    return res.data
  }

  async getProductTypesTrain(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-train-product-type/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getRenterCar(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-car-renter/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinationCarByName(name: string): Promise<any[]> {
    try {
      const res = await axios.get(`https://api-autocomplete.tije.travel/autocomplete/search`, {
        headers: { 'Content-Type': 'application/json' },
        params: {
          _format: 'json',
          flow_code: 'rentingcarz',
          product: 'rentingcarz',
          locale: 'es_AR',
          query: name,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTrainTypeOfService(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-train-type-of-service/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTrainRegion(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-train-region/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getMarketingCarrierTrain(params = null): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-train-marketing-carrier/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params ? params : {},
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTrainSupplier(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/ext-train-supplier/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateRuleView(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/update-view/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getFormulaGlobalVariables(params: any): Promise<FormulaGlobalVariablesOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BUSINESS_RULE}/formula-global-variables/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params && params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteFormulaGlobalVariable(id: number): Promise<FormulaGlobalVariablesOutputDTO[]> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_BUSINESS_RULE}/formula-global-variables/${id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const businessRuleServices = new BusinessRuleServices()
